<template>
  <modal name="profile-settings-modal" :clickToClose="false">
    <div class="modal-container">
      <div class="modal-header">
        <page-title class="modal-title">My Profile Settings</page-title>
        <p class="modal-description">Review or update your account settings below.</p>
      </div>
      <div class="modal-body">
        <div class="activity-tabs-wrapper">
          <div
            :class="{ 'activity-tab': true, active: activeTab === 1 }"
            @click="handleClickTab(1)"
          >
            Edit Profile
          </div>
          <div
            :class="{ 'activity-tab': true, active: activeTab === 2 }"
            @click="handleClickTab(2)"
          >
            Password
          </div>
          <div
            :class="{ 'activity-tab': true, active: activeTab === 3 }"
            @click="handleClickTab(3)"
          >
            Social
          </div>
        </div>
        <div class="tab-panel-wrapper">
          <edit-profile-panel
            class="profile-panel"
            v-show="activeTab === 1"
            @onSubscription="$emit('onSubscription')"
            @close="closeModal"
          />
          <password-setting-panel v-show="activeTab === 2" @close="closeModal" />
          <social-accounts-panel v-show="activeTab === 3" @close="closeModal" />
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import Loading from "vue-loading-overlay";
import RtPicture from "../common/Picture.vue";
import RtInput from "../common/Input.vue";
import PageTitle from "../common/PageTitle.vue";
import PrimaryButton from "../common/PrimaryButton.vue";
import EditProfilePanel from "../common/setting/EditProfilePanel.vue";
import NotificationPanel from "../common/setting/NotificationPanel.vue";
import PasswordSettingPanel from "../common/setting/PasswordSettingPanel.vue";
import { getUser } from "common/UserService";
import SocialAccountsPanel from "./setting/SocialAccountsPanel.vue";

export default {
  props: ["show"],
  components: {
    SocialAccountsPanel,
    Loading,
    RtPicture,
    RtInput,
    PageTitle,
    PrimaryButton,
    EditProfilePanel,
    NotificationPanel,
    PasswordSettingPanel
  },
  data: function () {
    return {
      loading: false,
      activeTab: 1,
      firstName: "",
      lastName: "",
      submitError: null,
      submitSuccessInfo: null
    };
  },
  watch: {
    show(newVal) {
      if (newVal) {
        this.$modal.show("profile-settings-modal");
        document.body.style.overflow = "hidden";
      }
    },
  },
  mounted() {
    const user = getUser();
    if (user) {
      this.firstName = user.firstName;
      this.lastName = user.lastName;
    }
  },
  methods: {
    handleClickTab(tab) {
      if (this.activeTab !== tab) {
        this.activeTab = tab;
      }
    },
    closeModal(profileUpdated) {
      document.body.style.overflow = "inherit";
      this.$modal.hide("profile-settings-modal");
      this.$emit("close", profileUpdated);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../common/variables";

.v--modal-overlay {
  background: rgba(20, 32, 53, 0.85) !important;
  z-index: 9999999999;
  ::v-deep(.v--modal-box) {
    background: transparent;
    box-shadow: none;
    top: 0 !important;
    left: 0 !important;
    width: 100% !important;
    height: 100% !important;
    .modal-container {
      display: flex;
      flex-direction: column;
      position: fixed;
      right: 0;
      width: 570px;
      height: 100%;
      background: #fff;
      padding: 56px 0 80px;
      transition: opacity 0.3s linear, right 0.3s ease-out;
      .modal-header {
        padding: 0 64px;
      }
      .modal-body {
        display: flex;
        flex-direction: column;
        flex: 1;
        min-height: 0;
        overflow-y: auto;
      }
      .modal-title {
        margin-bottom: 8px;
        font-size: 30px;
        color: $title-dark-grey;
      }
      .modal-description {
        font-weight: 400;
        font-size: 14px;
        color: $title-grey;
        .invite-learn-more {
          font-weight: 700;
          color: $light-blue2;
          cursor: pointer;
        }
      }
      .activity-tabs-wrapper {
        width: auto;
        margin: 25px 64px 0;
        .activity-tab {
          padding: 16px 24px;
          white-space: nowrap;
          color: $title-dark-grey;
          &.active {
            margin-bottom: 2px;
            border-radius: 12px 12px 0 0;
          }
        }
      }
      .tab-panel-wrapper {
        flex: 1;
        padding: 40px 64px 20px;
        overflow-y: auto;
        ::v-deep(input) {
          border: 0 !important;
        }
      }
    }
  }
}
</style>
